import { Group, Select, type MantineSize } from '@mantine/core'
import { YearPickerInput } from '@mantine/dates'
import { quarterOf, quarterStart, yearOf } from '../quarter'

const QUARTER_OPTIONS = [
  { value: '1', label: 'Q1' },
  { value: '2', label: 'Q2' },
  { value: '3', label: 'Q3' },
  { value: '4', label: 'Q4' },
]

/**
 * Quarter period picker — a year picker plus a Q1–Q4 select. The value in and
 * out is the ISO date of the quarter's first day (e.g. 2026-04-01 for Q2 2026).
 */
export function QuarterPickerInput({
  size,
  value,
  onChange,
  disabled,
}: {
  size?: MantineSize
  value: string | null
  onChange: (value: string) => void
  disabled?: boolean
}) {
  const year = value ? yearOf(value) : null
  const quarter = value ? quarterOf(value) : null

  const emit = (y: number | null, q: number | null) => {
    if (y == null && q == null) {
      onChange('')
      return
    }
    onChange(quarterStart(y ?? new Date().getFullYear(), q ?? 1))
  }

  return (
    <Group gap="xs" grow align="end" wrap="nowrap">
      <YearPickerInput
        label="Year"
        size={size}
        valueFormat="YYYY"
        placeholder="Pick a year"
        value={year ? `${year}-01-01` : null}
        onChange={(v) => emit(v ? yearOf(v) : null, quarter)}
        disabled={disabled}
        clearable
      />
      <Select
        label="Quarter"
        size={size}
        data={QUARTER_OPTIONS}
        placeholder="Pick a quarter"
        value={quarter ? String(quarter) : null}
        onChange={(v) => emit(year, v ? parseInt(v, 10) : null)}
        disabled={disabled}
        clearable
      />
    </Group>
  )
}
